<p>choose-child works!</p>
